import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
const faqs = [['¿Necesito tener un diagnóstico confirmado de SIBO?', 'No es obligatorio. El protocolo es educativo y está pensado para quienes conviven con hinchazón, gases y digestiones pesadas, con o sin diagnóstico confirmado.'], ['¿Cuándo puedo empezar a aplicarlo?', 'Desde el primer día. Podés incorporar las herramientas mientras avanzás por los volúmenes.'], ['¿Tengo que comprar suplementos o productos caros?', 'No. El plan usa alimentos e ingredientes de supermercado, con opciones simples y económicas.'], ['¿La garantía es real?', 'Sí. Tenés 14 días de garantía y podés solicitar la devolución dentro de ese período si el protocolo no es para vos.'], ['¿Es 100% digital?', 'Sí. Recibís el PDF por email y podés usarlo desde celular, tablet o computadora, o imprimirlo.'], ['¿Garantiza que mis síntomas desaparezcan?', 'No. Cada cuerpo responde distinto. El protocolo te da un método ordenado para observar, ajustar y sostener cambios con más claridad.']] as const;
const costs = ['Seguir comiendo a ciegas, sin un plan claro', 'Hinchazón y gases que se repiten todos los días', 'Gastar en dietas y productos que no resuelven nada', 'Culpa después de cada comida que “cayó mal”', 'Salidas y planes que evitás por miedo a los síntomas', 'Cansancio y falta de energía sin dirección'];
const purchases = [['Roxana M.', 'Buenos Aires'], ['Valeria S.', 'La Plata'], ['Daniela R.', 'Quilmes'], ['Silvia G.', 'San Isidro']];
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-20" data-mp="21ybzavov8ls2">
        <div className="mx-auto max-w-3xl text-center" data-id="element-21" data-mp="1e9sskklgsh23">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-22" data-mp="19br6dqsqs1me" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-23" data-mp="1yzv9kuts8k6q">
            GARANTÍA 14 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-24" data-mp="230p07vym0d3b">
            <p className="text-slate-300" data-id="element-25" data-mp="27rowcyzwmr4r">Abrís los volúmenes. Aplicás el protocolo.</p>
            <p className="mt-4 text-slate-300" data-id="element-26" data-mp="2cr09zz4z5gi4">
              Si en 14 días no es lo que esperabas, te devolvemos el 100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-27" data-mp="1g2c606q3ftrp">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-28" data-mp="1p1p7od7z7e1v">sin formularios, sin drama.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-29" data-mp="1u0seo37inuch">Tasa de devoluciones: menos del 1%.</p>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-30" data-mp="30hdun4l8cd2o">
        <div className="mx-auto max-w-3xl" data-id="element-31" data-mp="30iyp6u7jnw0j">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-32" data-mp="35f5z0y329rnr">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-33" data-mp="ts2gdmalmwvy">
            {faqs.map(([question, answer], index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-34" data-mp="k1qzz09qav86" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-35" data-mp="f2xtvswru6i1">
                    <span data-id="element-36" data-mp="3sar6fp41xqqe">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-37" data-mp="3sbsmy93u75fi" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-38" data-mp="1yklt92eimbdg">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-39" data-mp="23hlxr8vpv62g">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-40" data-mp="1kjswsc4nl67p">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-41" data-mp="10vk2nwjjuq5k">
      <div className="mx-auto max-w-4xl" data-id="element-42" data-mp="10v0isaac9row">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-43" data-mp="i6zug551exbd">
          ⚖️ ¿CUÁNTO CUESTA NO TENER EL PROTOCOLO?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-44" data-mp="dahtzhgqpl4u">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-45" data-mp="m93890f6idzt">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-46" data-mp="11411dvi5j7hy">
                ×
              </span>
              {item}
            </p>)}
        </div>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-47" data-mp="glg2lbwphna2">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-48" data-mp="llaqd6l6pwqw">
          🎯 PROTOCOLO RESCATE SIBO™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-49" data-mp="vb40s49lc5tk">
          Sistema completo de alimentación y seguimiento para personas con SIBO.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-50" data-mp="10c1jchyij1vl">
          “No podés elegir tus síntomas, pero sí cómo acompañarlos.”
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-51" data-mp="199kam42r2cfx">
          <a className="hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-52" data-mp="363yj23xl01am">
            📧 soportebiomalivido@gmail.com
          </a>
          <span data-id="element-53" data-mp="3b3t8s45meku3">📲 @biomalivido</span>
          <a className="hover:text-brand-light" href="https://biomalivido.com" target="_blank" rel="noreferrer" data-id="element-54" data-mp="33iqq0nv49ntc">
            🌐 biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-55" data-mp="2tsnsqbgypnp7">
          © PROTOCOLO RESCATE SIBO™ 2026 — Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-56" data-mp="2ov5pn1pmm2p4">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-57" data-mp="3mh33glt29juq">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-58" data-mp="213qld3eahbb8">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="1x25blqx1xd59" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-60" data-mp="zfxc3j1arc">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-61" data-mp="4yhfibvnmdmo">compró el Protocolo Rescate SIBO™</p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-62" data-mp="3n8bcfoqpwgrr">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}